'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BrowserUserAgent = function () {
  function BrowserUserAgent() {
    (0, _classCallCheck3.default)(this, BrowserUserAgent);
  }

  (0, _createClass3.default)(BrowserUserAgent, null, [{
    key: 'is_chrome',
    value: function is_chrome() {
      return navigator.userAgent.toLowerCase().indexOf('chrome') > -1;
    }
  }, {
    key: 'is_ie',
    value: function is_ie() {
      return navigator.userAgent.toLowerCase().indexOf('msie') > -1;
    }
  }, {
    key: 'is_ie11',
    value: function is_ie11() {
      return navigator.userAgent.toLowerCase().indexOf('trident') > -1;
    }
  }, {
    key: 'is_firefox',
    value: function is_firefox() {
      return navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
    }
  }, {
    key: 'is_safari',
    value: function is_safari() {
      return navigator.userAgent.toLowerCase().indexOf("safari") > -1;
    }
  }, {
    key: 'is_opera',
    value: function is_opera() {
      return navigator.userAgent.toLowerCase().indexOf("op") > -1;
    }
  }, {
    key: 'is_edge',
    value: function is_edge() {
      return navigator.userAgent.toLowerCase().indexOf("edge") > -1;
    }
  }]);
  return BrowserUserAgent;
}();

exports.default = BrowserUserAgent;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui/lib/utils/BrowserUserAgent.js
// module id = 868
// module chunks = 10